<template>
  <div class="main-content">
    <div class="container-fluid" :class="containerClass">
      <div class="row justify-content-center" :class="rowClass">
        <div :class="colClass">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    containerClass: {
      type: String,
      default: "",
    },
    rowClass: {
      type: String,
      default: "",
    },
    colClass: {
      type: String,
      default: "col-12",
    },
  },
});
</script>
